import { render, staticRenderFns } from "./CreateIndexModal.vue?vue&type=template&id=98c520dc&"
import script from "./CreateIndexModal.vue?vue&type=script&lang=js&"
export * from "./CreateIndexModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports